export const name = "ACOS";
export const summary = `Computes the inverse cosine of \`X\`.`;
export const reference = `
## ACOS

Computes the inverse cosine of \`X\`.

\`\`\`
ACOS(X)
\`\`\`

### Description

Computes the principal value of the inverse cosine of X. The return value is in the range [0,π]. Generates an error if X is a value outside of the range [-1, 1].

| X | ACOS(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |
| X \\< -1 | Error |
| X \\> 1 | Error |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
